import { FunctionComponent } from 'react'

import { ISnackBarProps, IAlertProps } from './SnackBarComponenet.types'
import { Container, Content, StyledAlertTitle } from './styles'

const SnackBar: FunctionComponent<ISnackBarProps & IAlertProps> = ({
  message,
  setOpen,
  open,
  severity,
  horizontal,
  vertical,
  duration,
  title,
}) => {
  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
  }
  return (
    <Container
      open={open}
      setOpen={setOpen}
      autoHideDuration={duration || 6000}
      onClose={handleClose}
      anchorOrigin={{
        horizontal: horizontal ?? 'center',
        vertical: vertical ?? 'bottom',
      }}
      key={(horizontal ?? 'center') + (vertical ?? 'bottom')}
    >
      <Content
        severity={severity}
        onClose={handleClose}
        style={{
          height: 'auto',
          lineHeight: '28px',
          padding: 10,
          whiteSpace: 'pre-line',
        }}
      >
        {title && (
          <StyledAlertTitle severity={severity}>{title}</StyledAlertTitle>
        )}
        {message}
      </Content>
    </Container>
  )
}

export default SnackBar
